export default __webpack_public_path__ + "static/media/spring.5ff55f64.png";